import React, { useMemo } from 'react';
import { Segment, Tabs, TabPanel } from 'tea-component';
import CardCommon from '@op/components/CardCommon';
import SubscriptionsTable from './SubscriptionsTable';
import { REPEAT_SUMMARY_TASK, TabType } from '../../hooks';
import useTabHistory from '@op/hooks/useTabHistory';

interface ISubscriptionsSummaryListTableProps {
  filter: any;
  keys: string[];
  gameInfoMap?: Record<string, any>;
  deleteToggleState: () => void;
  tabs: any[];
  defaultTab?: TabType;
  GENERATE_REPEAT_REPORT: boolean;
}

export default function SubscriptionsSummaryListTable({
  filter,
  keys,
  gameInfoMap,
  deleteToggleState,
  tabs,
  defaultTab = 'repeat_summary_task',
  GENERATE_REPEAT_REPORT,
}: ISubscriptionsSummaryListTableProps) {
  const { tab, onActive } = useTabHistory<TabType>({
    defaultValue: defaultTab,
    key: 'subtitle',
  });

  const segmentOptions = useMemo(() => {
    if (GENERATE_REPEAT_REPORT) {
      onActive({ id: 'keyword' });
      return tabs.filter((item) => item.id !== REPEAT_SUMMARY_TASK);
    }
    return tabs;
  }, [tabs, GENERATE_REPEAT_REPORT]);

  return (
    <>
      {segmentOptions?.length > 1 && (
        <Segment
          className="segment-font12"
          style={{ marginBottom: 10 }}
          value={tab}
          onChange={(value: TabType) => {
            onActive({ id: value });
          }}
          options={segmentOptions}
        />
      )}

      <Tabs
        className="dbo-hide-tabs"
        tabs={tabs}
        activeId={tab}
        destroyInactiveTabPanel={false}
      >
        {tabs.map((item) => {
          const { value, total, empty } = item;
          return (
            <TabPanel key={value} id={value}>
              <CardCommon
                contentCard
                emptyHeight={500}
                empty={total === 0}
                {...empty}
              >
                <SubscriptionsTable
                  filter={filter}
                  keys={keys}
                  gameInfoMap={gameInfoMap}
                  deleteToggleState={deleteToggleState}
                  tab={value}
                  urlTab={'repeat_summary_task'}
                />
              </CardCommon>
            </TabPanel>
          );
        })}
      </Tabs>
    </>
  );
}
